import React from "react";
import { TileImage } from "@/components/common/Skeleton";

// Rank border colours match the Avatar ring / SubscriberBadge hex. In a dense
// overlapping stack a full metallic ring turns to mud, so here the rank shows as a
// 2px coloured rim instead. member (101+) and no-rank keep the neutral bg rim.
const RANK_BORDER = {
  founding: "#D4AF37",
  pioneer: "#B8BCC4",
  charter: "#CD7F32",
  don: "#7C3AED",
};

// Avatar stack: 36px circles, -10px overlap, 2px --bg-primary ring per new-theme.md.
// Falls back to first-initial on --accent-light when a subscriber has no photo.
export const AvatarStack = ({ avatars = [], size = 36 }) => {
  if (!avatars.length) return null;
  return (
    <div className="flex items-center" data-testid="avatar-stack">
      {avatars.map((a, i) => {
        const rim = RANK_BORDER[a.ring] || "var(--bg-primary)";
        const base = {
          width: size,
          height: size,
          borderRadius: "50%",
          border: `2px solid ${rim}`,
          marginLeft: i === 0 ? 0 : -10,
          objectFit: "cover",
        };
        return a.avatar ? (
          <span key={i} style={{ ...base, overflow: "hidden", position: "relative", display: "block" }} data-testid={`avatar-${i}`}>
            <TileImage src={a.avatar} alt={a.name || "subscriber"} className="w-full h-full object-cover" />
          </span>
        ) : (
          <div
            key={i}
            style={{
              ...base,
              background: "var(--accent-light)",
              color: "var(--accent-primary)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: '"Host Grotesk", sans-serif',
              fontWeight: 600,
              fontSize: size * 0.4,
            }}
            data-testid={`avatar-${i}`}
          >
            {(a.initial || a.name?.[0] || "?").toUpperCase()}
          </div>
        );
      })}
    </div>
  );
};
